import type { IconAliases } from './icons';

const aliases: IconAliases = {
  itemAdd: 'fas fa-plus',
  itemCancel: 'fas fa-xmark',
  itemConfirm: 'fas fa-check',
  itemEdit: 'far fa-pen-to-square',
  itemMoveUp: 'fas fa-arrow-up',
  itemMoveDown: 'fas fa-arrow-down',
  itemDelete: 'fas fa-trash',
  search: 'fas fa-magnifying-glass',
  treeExpand: 'fas fa-chevron-right',
  treeCollapse: 'fas fa-chevron-down',
  visibilityOff: 'far fa-eye-slash',
  visibilityOn: 'far fa-eye',
  calendarClock: 'fas fa-calendar',
  clock: 'far fa-clock',
  passwordHide: 'far fa-eye-slash',
  passwordShow: 'far fa-eye',
  typeArray: 'fas fa-list',
  typeBoolean: 'fas fa-toggle-on',
  typeNull: 'fas fa-ban',
  typeNumber: 'fas fa-hashtag',
  typeObject: 'far fa-folder',
  typeString: 'fas fa-font',
  typeUnknown: 'fas fa-circle',
  validationError: 'fas fa-circle-exclamation',
};

export { aliases };
